"use client";

import { MainGalleryFilters } from "./main-gallery-filters";
import { MainGalleryDestinations } from "./main-gallery-destinations";

export function MainGallerySelectors() {
  return (
    <div className="grid grid-flow-row gap-6">
      <div className="flex w-full flex-col items-center justify-between lg:flex-row gap-8">
        <MainGalleryFilters />
        <MainGalleryDestinations />
      </div>
    </div>
  );
}
